export default __webpack_public_path__ + "static/media/kish.61ec0998.jpg";